import AxiosWrapper from "../../basecomp/base/AxiosWrapper"
import { fetchData } from "../apis/apis"




export async function CompletedTicketsDevApi(url) {
//      let response = await AxiosWrapper.axiosGetCallWithToken(url,new FormData())
        let response= fetchData(url,new FormData())

        
        return response
}
export async function AssignedTicketDevsApi(url) {
        let response= fetchData(url,new FormData())

//      let response = await AxiosWrapper.axiosGetCallWithToken(url,new FormData())
        
        return response
}